import { request } from '@/utils/request'

export const ProviderJobTitleService = {
    ignore(id) {
        return request.delete(`/api/manage/provider-job-titles/${id}`)
    },
}
